import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Youtube } from "lucide-react";

interface Video {
  id: string;
  title: string;
  description: string;
}

const YoutubeVideos = () => {
  const [videos] = useState<Video[]>([
    {
      id: "M_Y3TahVnnM",
      title: "On The Trail of the Loch Ness Monster",
      description: "Following the legend of the mysterious Loch Ness creature"
    },
    {
      id: "vpHu378Lvko",
      title: "Nessie Up Close",
      description: "Exclusive footage from my latest Loch Ness expedition"
    },
    {
      id: "CJFN1ZqZRfs",
      title: "My Loch Ness Adventures",
      description: "Join me on my personal exploration of the mysterious Loch Ness"
    }
  ]);

  return (
    <section className="py-12">
      <div className="flex items-end justify-between mb-2">
        <div>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground">Video Channel</h2>
          <p className="text-muted-foreground mt-2">Expeditions, interviews, and analysis from the loch.</p>
        </div>
        <a href="https://www.youtube.com/@LochNessStories" target="_blank" rel="noopener noreferrer" className="hidden md:block">
          <Button variant="outline" size="sm" className="flex items-center gap-2 border-border text-muted-foreground hover:text-foreground">
            <Youtube className="h-4 w-4" />
            Subscribe
          </Button>
        </a>
      </div>
      <div className="h-px bg-border mt-6 mb-8" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {videos.map((video) => (
          <Card key={video.id} className="bg-card border-border overflow-hidden hover:border-accent/30 transition-colors">
            <div className="aspect-video">
              <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${video.id}`}
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <CardContent className="p-4">
              <h3 className="font-semibold text-base mb-1 text-foreground">{video.title}</h3>
              <p className="text-muted-foreground text-sm">{video.description}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      <a href="https://www.youtube.com/@LochNessStories" target="_blank" rel="noopener noreferrer" className="md:hidden block mt-6">
        <Button variant="outline" size="sm" className="flex items-center gap-2 border-border text-muted-foreground">
          <Youtube className="h-4 w-4" />
          Subscribe to Channel
        </Button>
      </a>
    </section>
  );
};

export default YoutubeVideos;
